import {Util} from 'yougile-util'
import {DataObjectId, Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {Company} from '@extensions/company'
import {ImportFromFileStore} from '../import-from-file-store'
import {State} from '../types'
import {processRow} from './process-row'

export type ProcessRowsProps = {
  state: State
  store: ImportFromFileStore
  company: Company
  tableData: Record<string, string>[]
  tableDataOrig: Record<string, string>[]
  emptyProjectTitle?: string
  projectsCache: Record<string, Hub>
  createdProjectNames: string[]
  addedTasks: Record<string, DataObjectId>
  processedTasks: Record<string, boolean>
}

export const processRows = async (props: ProcessRowsProps): Promise<void> => {
  const {state, tableData, createdProjectNames, addedTasks} = props
  const box = Sync.getCurrentSandbox()

  let counter = 0
  for (const row of tableData) {
    counter++
    if (counter % 100 === 0) {
      await Util.wait(1000)
    }

    processRow({...props, row, addedTasks, box})
  }

  state.projectNames = new Set([...state.projectNames, ...createdProjectNames])
}
